<template>
	<v-layout wrap>
		<v-flex xs12>
			<v-col cols="12">
				<v-row>
					<v-flex xs6>
						<!-- фильтры -->
						<v-select
							v-model="filtersSelectedInner"
							:items="filters"
							label="Фильтры"
							item-text="label"
							item-value="value"
							multiple
							outlined
							clearable
						>
							<template
								slot="selection"
								slot-scope="data"
							>
								{{ data.item.label }}
							</template>
							<template
								slot="item"
								slot-scope="data"
							>
								<template v-if="typeof data.item !== 'object'">
									{{data.item}}
								</template>
								<template v-else>
									{{data.item.label}}
								</template>
							</template>
						</v-select>
					</v-flex>
					<v-flex xs6>
						<!-- вес -->
						<v-select
							v-model="weightInner"
							:items="weight"
							item-text="label"
							item-value="value"
							label="Вес"
							outlined
						>
						</v-select>
					</v-flex>
				</v-row>
			</v-col>
		</v-flex>
	</v-layout>
</template>

<script>
  export default {
    name: "Params",
    data() {
      return {
        rules: {
          validate: (val) => {
            if (!val) return true;
            const pattern = /^[\d|\.]+$/;
            return pattern.test(val) || 'Разрешены только числа или пустота'
          }
        },
        valid: false,
      }
    },
    props: {
      items: Array,
      filters: Array,
      filtersSelected: Array,
      updateFilters: Function,
      weight: Array,
      weightSelected: String,
      updateWeight: Function,
    },
    computed: {
      filtersSelectedInner: {
        get: function () {
          return this.filtersSelected;
        },
        set: function (val) {
          this.updateFilters(val);
        }
      },
      weightInner: {
        get: function () {
          return this.weightSelected
        },
        set: function (val) {
          this.updateWeight(val)
        },
      },
    },
    methods: {
      selectItem: function (val, item) {
        if (item.type === 'open_value' && val !== null) {
          this.$data.openCategory = {
            dialog: true,
            category: item.value,
            verbose: item.label,
          };
        }
      },
    },
  };
</script>

<style scoped>

</style>
